import moment from 'moment';
import 'moment/locale/uk';
import 'moment/locale/en-gb';
import { INIT_UI_LANGUAGE } from 'constants/languages';

export default function getLocalizedDate(date) {
  const splitSeparatorByLanguage = {
    uk: ' о ',
    en: ' at ',
  };
  return `${
    moment(date).locale(INIT_UI_LANGUAGE).calendar().split(splitSeparatorByLanguage[INIT_UI_LANGUAGE])[0] //ХАК!
  }, ${moment(date).locale(INIT_UI_LANGUAGE).format('D MMMM')}`;
}
